const { getOffsetTop } = window.BAO.Utils

class ProductFixedBar extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.isTicking = false
    this.lastKnownY = window.scrollY
    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)

    this.updateEl()
  }

  setupListeners () {
    super.setupListeners()

    this.handleTrigger = this.handleTrigger.bind(this)
    this.onScroll = this.onScroll.bind(this)

    this.els.trigger.elements.forEach((triggerEl) => {
      this.listeners.add(triggerEl, 'click', this.handleTrigger)
    })

    this.listeners.add(window, 'scroll', this.onScroll)
  }

  handleTrigger () {
    this.externalEls?.form?.element.scrollIntoView({
      behavior: 'smooth',
      block: 'end',
    })
  }

  onScroll () {
    this.lastKnownY = window.scrollY
    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)
    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    this.setVisibility()
  }

  setVisibility () {
    this.classList.toggle('prd-FixedBar-hidden', !this.shouldBeVisible)
  }

  get shouldBeVisible () {
    if (!this.externalEls?.form?.exists) return

    const topStart = this.externalEls.form.element
    const bottomEnd = this.externalEls.footer.element

    if (
      this.lastKnownY > getOffsetTop(topStart) + topStart.offsetHeight &&
      this.lastKnownY < getOffsetTop(bottomEnd) - window.innerHeight
    ) {
      return true
    } else {
      return false
    }
  }
}

if (!customElements.get('product-fixed-bar')) {
  customElements.define('product-fixed-bar', ProductFixedBar)
}
